var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "payment-type-options" } }, [
      _c("button", { staticClass: "google-pay-button pay-button" }, [
        _c("div", {
          staticClass: "sprite google-pay-light disabled-image",
          attrs: { id: "googlepay-mark" },
        }),
      ]),
      _c(
        "button",
        {
          staticClass: "apple-pay-button no-apple-pay",
          attrs: { id: "nspay-apple-pay" },
        },
        [
          _c(
            "div",
            { staticClass: "apple-pay-button-container disabled-image" },
            [_c("div", { attrs: { id: "apple-pay-logo" } })]
          ),
        ]
      ),
      _c("div", { attrs: { id: "i4goFrame" } }),
      _c("form", { attrs: { id: "form-main" } }, [
        _c("input", {
          attrs: { id: "i4go_response", name: "i4go_response", type: "hidden" },
        }),
        _c("input", {
          attrs: {
            id: "i4go_responsecode",
            name: "i4go_responsecode",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_responsetext",
            name: "i4go_responsetext",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: { id: "i4go_cardtype", name: "i4go_cardtype", type: "hidden" },
        }),
        _c("input", {
          attrs: {
            id: "i4go_maskedcard",
            name: "i4go_maskedcard",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: { id: "i4go_uniqueid", name: "i4go_uniqueid", type: "hidden" },
        }),
        _c("input", {
          attrs: {
            id: "i4go_expirationmonth",
            name: "i4go_expirationmonth",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_expirationyear",
            name: "i4go_expirationyear",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_cardholdername",
            name: "i4go_cardholdername",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_streetaddress",
            name: "i4go_streetaddress",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_postalcode",
            name: "i4go_postalcode",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_extendedcarddata",
            name: "i4go_extendedcarddata",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: { id: "i4go_utoken", name: "i4go_utoken", type: "hidden" },
        }),
        _c("input", {
          attrs: {
            id: "i4go_googlepaytoken",
            name: "i4go_googlepaytoken",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_applepaytoken",
            name: "i4go_applepaytoken",
            type: "hidden",
          },
        }),
        _c("input", {
          attrs: {
            id: "i4go_signeddata",
            name: "i4go_signeddata",
            type: "hidden",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }